<template>
  <div class="cube1">
    <div>
      <div>{{title}}</div>
      <EditBtn v-if="!edit" @click="$emit('edit')" :style="{marginLeft: 'auto'}" v-show="!noteditable"/>
      <slot name="btns"/>
      <slot name="btns-edit" v-if="edit"/>
    </div>
    <div v-if="edit">
      <slot name="edit"></slot>
      <Btns :style="{marginTop: '20px'}" @save="$emit('save')" @cancel="$emit('cancel')"/>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Btns from '../btn/btns.vue'
import EditBtn from '../btn/editConvert.vue'
export default {
  props: ['title', 'onEdit', 'edit', 'noteditable'],
  components: {
    EditBtn,
    Btns
  },
  data () {
    return {
    }
  }

}
</script>

<style lang="scss" scoped>
.cube1 {
  width: -webkit-fill-available;
  min-height: 135px;
  height: fit-content;
  margin-top: 25px;
  border: 1px solid var(--color-pri);
  border-radius: 10px;
  &>div:nth-child(1) {
    height: 45px;
    background-color: var(--color-pri);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-inline: 30px 20px;
    border-radius: 10px 10px 0 0;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    line-height: 15px;
    letter-spacing: 2px;
  }
  &>div:nth-child(2) {
    padding: 15px 40px;
  }
}
</style>
